module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero15.png?72ad5850";